import { QueryClient } from '@tanstack/react-query';

export function invalidatePiiRelatedQueries(queryClient: QueryClient): void {
  void queryClient.invalidateQueries({
    predicate: (query) => {
      const key = query.queryKey[0];
      return (
        key === 'idpProfile' ||
        key === 'leadsRevival' ||
        key === 'piiEndTime' ||
        key === 'campaignOverviewInventory' ||
        key === 'campaignOverviewShoppers' ||
        key === 'idpRevealProfile' ||
        key === 'campaignOverviewInventoryShoppers'
      );
    },
  });
}
